import { render, staticRenderFns } from "./EvaOfTeacher.vue?vue&type=template&id=4de08ddd&scoped=true&"
import script from "./EvaOfTeacher.vue?vue&type=script&lang=js&"
export * from "./EvaOfTeacher.vue?vue&type=script&lang=js&"
import style0 from "./EvaOfTeacher.vue?vue&type=style&index=0&id=4de08ddd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de08ddd",
  null
  
)

export default component.exports